import { useCallback, useEffect, useRef, useState } from "react";

/**
 * Hook to detect newly added files from a file list
 * Tracks which files are new compared to previous renders
 */
export const useNewFileDetection = (files: File[]) => {
  const [newFiles, setNewFiles] = useState<File[]>([]);
  const previousFilesRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const currentNames = new Set(files.map((f) => f.name));
    const added = files.filter((f) => !previousFilesRef.current.has(f.name));

    // Always keep previousFilesRef in sync (handles removals too)
    previousFilesRef.current = currentNames;

    if (added.length > 0) {
      setNewFiles(added);
    }
  }, [files]);

  const clearNewFiles = useCallback(() => setNewFiles([]), []);

  return {
    newFiles,
    newFileNames: newFiles.map((f) => f.name),
    clearNewFiles,
  };
};
